<script lang="ts" module>
  import type { TeoText } from '@/teoCore/text/TeoText';
  import { useActiveTextUIViewValue } from '@/utils/teo-context/teo-atoms/text';

  import ColumnHeadline from '../../elements/column-headline/ColumnHeadline.svelte';
  import BrandFitComponent from './BrandFit/BrandFitComponent.svelte';
  import DictionaryComponent from './Dictionary/DictionaryComponent.svelte';
  import PerformanceComponent from './Performance/PerformanceComponent.svelte';
  import SpellCheckComponent from './SpellCheck/SpellCheckComponent.svelte';
  import StyleComponent from './Style/StyleComponent.svelte';
  import TextGeneratorView from './TextGenerator/TextGeneratorView.svelte';
  import VersionLogCard from './Versions/VersionLogCard.svelte';
</script>

<script lang="ts">
  const { teoText }: { teoText: TeoText } = $props();
  const view = useActiveTextUIViewValue();
</script>

{#if view.current === 'performance'}
  <ColumnHeadline text="Performance-Pilot" />
  <PerformanceComponent {teoText}></PerformanceComponent>
{:else if view.current === 'brand-scanner'}
  <ColumnHeadline text="Brand-Fit Assistent" />
  <BrandFitComponent {teoText}></BrandFitComponent>
{:else if view.current === 'style'}
  <ColumnHeadline text="Stil" />
  <StyleComponent {teoText}></StyleComponent>
{:else if view.current === 'dictionary'}
  <ColumnHeadline text="Assistent" />
  <DictionaryComponent {teoText}></DictionaryComponent>
{:else if view.current === 'spellcheck'}
  <ColumnHeadline text="Rechtschreibung" />
  <SpellCheckComponent {teoText}></SpellCheckComponent>
{:else if view.current === 'versions'}
  <ColumnHeadline text="Analyse Historie" />
  <VersionLogCard />
{:else if view.current === 'text-generator'}
  <ColumnHeadline text="Text Generator" />
  <TextGeneratorView />
{:else}
  <ColumnHeadline text="TODO" />
{/if}
